let Api = {
  

    "TRACE_DATATYPEMAGE_FIND": "/trace/w/datatypeMage/findList", //获取数据类型列表


    "TRACE_DATASHEET_SAVE": "/trace/w/datasheetInfo/save", //动态建表-保存数据表信息
    "TRACE_DATASHEET_PAGE": "/trace/w/datasheetInfo/findPage", //动态建表-数据表分页查询
    "TRACE_DATASHEET_DETAIL": "/trace/w/datasheetInfo/getDetail", //动态建表-数据表详情
    "TRACE_DATASHEET_DEL": "/trace/w/datasheetInfo/delById", //动态建表-数据表删除
    "TRACE_DATASHEET_TABLIST": "/trace/w/datasheetInfo/tabelList", //动态建表-查询该会员下的所有表名
    "TRACE_DATASHEET_TABDETAIL": "/trace/w/datasheetInfo/fieldListByTableId", //动态建表-查询该表名下的所有字段
    "TRACE_DATASHEET_SELDATALIST": "/trace/n/datasheetshow/selDataList", //动态建表-根据数据表参数字段查对应数据
    
    

    
    "TRACE_DATASHEET_DATA_INIT": "/trace/w/datasheetInfo/dataMageInit", //数据管理详情初始化查询
    "TRACE_DATASHEET_DATA_PAGE": "/trace/w/datasheetInfo/dataMageList", //数据管理答案分页查询
    "TRACE_DATASHEET_INITHTML": "/trace/n/datasheetshow/initHtml", //问卷调查答案详情
    "TRACE_DATASHEET_SAVEHTML": "/trace/n/datasheetshow/saveData", //问卷调查答案保存

    
    "TRACE_DATASHEET_SAVESTATUS": "/trace/w/datasheetInfo/statusSave", //数据管理采集开启/关停

    
    "TRACE_DATASHEET_IMPORTEMPLATE": "/trace/w/datasheetInfo/importTemplate", //数据管理导出模版
    "TRACE_DATASHEET_DELBYID": "/trace/w/datasheetInfo/delByIdForData", //数据管理答案删除by id
    "TRACE_DATASHEET_DELBYIDS": "/trace/w/datasheetInfo/delByIdsForData", //数据管理答案删除by ids
    "TRACE_DATASHEET_EXPORTDATA": "/trace/w/datasheetInfo/exportData", //数据管理导出所有数据


    
    "TRACE_DATASHEET_POSTERINIT": "/trace/w/datasheetInfo/posterInit", //数据管理-海报初始化
    "TRACE_DATASHEET_POSTERSAVE": "/trace/w/datasheetInfo/posterSave", //数据管理-海报保存
    
    
  }
  module.exports = Api